
export const usePolarCheckout = () => {
  const { user } = useAuth()
  const { $pb } = useNuxtApp();
  const token = $pb.authStore.token;

  const loading = ref(false)
  const error = ref(null)

  const createCheckout = async (productType) => {
    loading.value = true
    error.value = null
    
    try {
      const response = await $fetch(
        'api/checkout', 
        {
            method: 'POST',
            query: {
              productType: productType,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
        }
      )

      console.log(response.data);
      
      
      // Redirect to checkout URL
      window.location.href = response.url;

    } catch (err) {
        console.error('Checkout error:', err)
        error.value = err.message || 'Failed to create checkout session'
        throw err
    } finally {
        loading.value = false
    }
  }

  return {
    createCheckout,
    loading,
    error,
  }
}
